// src/components/ui/card.jsx
import React from 'react';
import { cn } from '../../lib/cn';

export const Card = ({ className, padding = 'none', children, ...props }) => {
  return (
    <div
      className={cn(
        'ds-surface',
        padding === 'none' && 'p-0',
        padding === 'sm' && 'p-3',
        padding === 'md' && 'p-4',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};

export const CardHeader = ({ className, children, ...props }) => {
  return (
    <div
      className={cn(
        'px-5 pt-5 pb-3',
        'flex flex-col gap-1',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};

export const CardTitle = ({ className, children, ...props }) => {
  return (
    <h3
      className={cn('text-lg font-semibold tracking-tight text-slate-900', className)}
      {...props}
    >
      {children}
    </h3>
  );
};

export const CardContent = ({ className, children, ...props }) => {
  return (
    <div className={cn('px-5 pb-5 pt-0', className)} {...props}>
      {children}
    </div>
  );
};
